import React from 'react';
import { Link } from 'react-router-dom';
import { Info } from 'lucide-react';

// Shown on every public listing. Establishes that details are seller-provided and
// unverified — the marketplace disclaimer that keeps liability with the seller.
// `mode` tailors the wording: a buyer inherits the vehicle, a renter does not.
export default function ListingDisclaimer({ mode = 'rental', className = '' }) {
  const buy = mode === 'sale';
  return (
    <div className={`flex items-start gap-2 rounded-lg border border-gray-200 bg-gray-50 p-3 ${className}`}>
      <Info className="w-4 h-4 text-gray-400 mt-0.5 shrink-0" />
      <p className="text-xs text-gray-500 leading-relaxed">
        Details here are provided by the {buy ? 'seller' : 'owner'} and are not verified by us.
        {buy
          ? ' Inspect the vehicle and check its documents (RC, insurance, permit, loan/NOC) before you pay.'
          : ' Confirm the vehicle, price and documents with the owner before you book.'}{' '}
        <Link to="/terms" className="text-blue-600 hover:underline">Terms apply</Link>.
      </p>
    </div>
  );
}
